import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { computed, ref, watch, watchEffect } from "vue";
import { useToggle } from "../../../composables/useToggle";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import SessionSlide from "../../sessions/session-slide.vue";
import StrengthsMappingWrapper from "../../sessions/strengths-mapping-wrapper.vue";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import { CmsStrengthMapping, QuestionnaireType } from "../../../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-mapping-slide',
  props: {
    slice: {},
    index: {},
    canReMapStrengths: { type: Boolean }
  },
  emits: ["onCollapse", "onIndicatorCollapse"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const prismicSlice = computed<CmsStrengthMapping>(() => {
  return props.slice.prismicSlice as CmsStrengthMapping;
});

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

const hasSubmittedMapping = ref(false);

const slide = ref<InstanceType<typeof SessionSlide> | null>(null);
const visualDiv = computed(() => slide?.value?.visualDiv);

const questionnaireType = computed(
  () => prismicSlice.value.primary?.questionnaire_type ?? "strengths",
);

function emitCollapseEvent(type: QuestionnaireType): void {
  if (type === "strengths" && !hasSubmittedMapping.value) {
    emit("onCollapse", props.index);
  }
  if (type === "indicators") {
    emit("onIndicatorCollapse", props.index);
  }
}

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

watch(
  () => cmsSessionStore.hasFinishedMapping,
  (newVal) => {
    if (newVal[questionnaireType.value]) {
      emitCollapseEvent(questionnaireType.value);
      hasSubmittedMapping.value = true;
      cmsSessionStore.updateSectionStatus(props.slice.section, true);
    }
  },
  { deep: true, immediate: true },
);

__expose({
  slide,
  visualDiv,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SessionSlide, {
    ref_key: "slide",
    ref: slide,
    id: 'slide' + props.index,
    "visual-position": "fixed",
    class: _normalizeClass({
      'slide-after-activity': !_unref(isDisplayed),
      'submitted-mapping': hasSubmittedMapping.value,
      'strengths-mapping': questionnaireType.value === 'strengths',
      'indicators-mapping': questionnaireType.value === 'indicators',
    }),
    "data-test": `session-slide-${_ctx.index}`
  }, {
    text: _withCtx(() => [
      _createVNode(_Transition, { name: "submitted" }, {
        default: _withCtx(() => [
          (!_unref(cmsSessionStore).hasFinishedMapping[questionnaireType.value])
            ? (_openBlock(), _createBlock(StrengthsMappingWrapper, {
                key: 0,
                id: "strengths-mapping",
                "can-re-map-strengths": props.canReMapStrengths,
                "questionnaire-type": questionnaireType.value,
                "data-test": 
            questionnaireType.value === 'strengths'
              ? 'strength-questionnaire-slide'
              : 'indicator-questionnaire-slide'
          
              }, null, 8, ["can-re-map-strengths", "questionnaire-type", "data-test"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "class", "data-test"]))
}
}

})